import type { ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

interface InfoRowProps {
    label: string;
    value: ReactNode;
    icon?: IconDefinition;
}

// One "label ... value" line of the side panels
const InfoRow = ({ label, value, icon }: InfoRowProps) => (
    <div className="w-full flex justify-between items-center p-5 border-b-2 border-gray-200">
        <span className="block font-bold text-lg">{label}</span>
        <span>
            <span>{value}</span>
            {icon && <FontAwesomeIcon icon={icon} className="mr-2" />}
        </span>
    </div>
);

export default InfoRow;